import TicketType from "../model/TicketType";
import { promiseRequest } from "./ServiceApi";
import { ServiceApi } from "./ServiceApiWithLoading";

export default class TicketTypeApi extends ServiceApi<TicketType> {

    constructor() {
        super('ticketType');
        this.updateProdEngUserComments = this.updateProdEngUserComments.bind(this);
        this.updateProdEngUserAddPerms = this.updateProdEngUserAddPerms.bind(this);
        this.updateUserApprovalEmails = this.updateUserApprovalEmails.bind(this);
        this.updateProdEngTags = this.updateProdEngTags.bind(this);
        this.updateDepartments = this.updateDepartments.bind(this);
    }

    async updateProdEngUserComments(id: number|string, list: number[] | null) {
        var baseUrl = this.getBaseUrl();
        var result = await await this.promiseWithLoading(promiseRequest(baseUrl + `${id}/updateProdEngUserComments/`, 'PUT', list || undefined, true));
        return result;
    }

    async updateProdEngUserAddPerms(id: number|string, list: number[] | null) {
        var baseUrl = this.getBaseUrl();
        var result = await await this.promiseWithLoading(promiseRequest(baseUrl + `${id}/updateProdEngUserAddPerms/`, 'PUT', list || undefined, true));
        return result;
    }

    async updateUserApprovalEmails(id: number|string, list: number[] | null) {
        var baseUrl = this.getBaseUrl();
        var result = await await this.promiseWithLoading(promiseRequest(baseUrl + `${id}/updateUserApprovalEmails/`, 'PUT', list || undefined, true));
        return result;
    }

    async updateProdEngTags(id: number|string, list: number[] | null) {
        var baseUrl = this.getBaseUrl();
        var result = await await this.promiseWithLoading(promiseRequest(baseUrl + `${id}/updateProdEngTags/`, 'PUT', list || undefined, true));
        return result;
    }

    async updateDepartments(id: number | string, list: number[] | null) {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `${id}/departments/`, 'PUT', list || undefined, true));
        return result;
    }

}